import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { TableCol } from "../table-col/TableCol";
import { TableCaption } from "../table-caption/TableCaption";
import { TableBody } from "./TableBody";
import { TableHead } from "./TableHead";
/* eslint-enable @m/magic/no-re-exports */
export class TableWithData extends React.PureComponent {
    headerRef = React.createRef();
    state = {
        sortIndex: this.props.sortIndex || 0,
        sortDirection: this.props.sortDirection || "descending",
        sortMethod: this.props.createSortMethodFor
            ? this.props.createSortMethodFor(this.props.sortIndex || 0, this.props.sortDirection || "descending")
            : undefined
    };
    sort = (columnIndex, direction, colSortMethod) => {
        const { createSortMethodFor } = this.props;
        let sortMethod = createSortMethodFor && createSortMethodFor(columnIndex, direction);
        if (colSortMethod) {
            sortMethod = colSortMethod;
        }
        this.setState({
            sortMethod,
            sortDirection: direction,
            sortIndex: columnIndex
        });
    };
    renderHeaderContent = () => {
        const { data } = this.props;
        const { sortIndex, sortDirection } = this.state;
        return _jsx(TableHead, { headData: data.head, sort: this.sort, sortIndex: sortIndex, sortDirection: sortDirection });
    };
    render() {
        const { children, data } = this.props;
        const { sortMethod } = this.state;
        return (_jsxs(_Fragment, { children: [children, data.caption && _jsx(TableCaption, { isVisuallyHidden: data.shouldVisuallyHideCaption, children: data.caption }), data.colgroup && (_jsx("colgroup", { children: data.colgroup.map((col, i) => (_jsx(TableCol, { ...col }, i))) })), _jsx("thead", { children: this.renderHeaderContent() }), _jsx(TableBody, { bodyData: data.body, sortMethod: sortMethod })] }));
    }
}
